import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  faTimes,
  faAsterisk,
  faSave,
  faTrash,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import GetAdminService from "../../../services/admin/GetAdminService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomLoader from "../../customLoader/CustomLoader";
import swal from "sweetalert";
import { Modal, ModalBody } from "reactstrap";

const MessageModal = ({ isOpen, setIsOpen, data }) => {
  return (
    <Fragment>
      <Modal isOpen={isOpen} centered={true}>
        <ModalBody>
          <div style={{ textAlign: "center" }}>
            <p>{data.message}</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={data.function1}
                style={{
                  backgroundColor: "#009900",
                  color: "white",
                  padding: "5px",
                  border: "none",
                  outline: "none",
                  marginRight: "20px",
                  borderRadius: "5px",
                }}
              >
                <FontAwesomeIcon
                  style={{ margin: "0 5px" }}
                  color="white"
                  icon={faCheck}
                />
                Ok
              </button>
              <button
                onClick={() => setIsOpen(false)}
                style={{
                  backgroundColor: "#efefef",
                  color: "black",
                  padding: "5px",
                  border: "none",
                  outline: "none",
                  marginLeft: "20px",
                  borderRadius: "5px",
                }}
              >
                <FontAwesomeIcon style={{ margin: "0 5px" }} icon={faTimes} />
                Cancel
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

const CreateCounselor = ({
  setOpenCreateCounselor,
  modify,
  school_id,
  getPageData,
  school_name,
}) => {
  const timeoutRef = useRef();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [recoveryEmail, setRecoveryEmail] = useState();
  const [mobile, setMobile] = useState();
  const [promote, setPromote] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [showCounselorContainer, setShowCounselorContainer] = useState(false);
  const [showPasswordError, setShowPasswordError] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [schoolName, setSchoolName] = useState();
  const [showSchoolNameContainer, setShowSchoolNameContainer] = useState(false);
  const [schoolNameList, setSchoolNameList] = useState();
  const schoolNameRef = useRef();
  const [schoolNameLoading, setSchoolNameLoading] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState([]);

  const getSchoolsList = (value) => {
    setSchoolNameLoading(true);
    setShowSchoolNameContainer(true);
    GetAdminService.getSchoolsList(value)
      .then((data) => {
        console.log("data from the service", data);
        setSchoolNameList(data?.data?.school);
        setSchoolNameLoading(false);
      })
      .catch((error) => {
        console.log("error from the service", error);
        setSchoolNameLoading(false);
      });
  };

  console.log(modify, school_id);

  const modifyData = () => {
    setFirstName(modify?.counselor?.first_name || "");
    setLastName(modify?.counselor?.last_name || "");
    setEmail(modify?.counselor?.email || "");
    setRecoveryEmail(modify?.counselor?.recovery_email || "");
    setMobile(modify?.counselor?.mobile || "");
    setPromote(modify?.counselor?.is_super_counselor);
    let arr = [];
    arr.push(modify["school"]);
    setSelectedSchool(arr[0]);
  };

  const setNull = () => {
    console.log("first");
    setSelectedSchool([]);
    setFirstName("");
    setLastName("");
    setEmail("");
    setMobile("");
    setPassword("");
    setConfirmPassword("");
  };

  const passwordValidation = (value) => {
    if (password.length < 8) {
      setShowPasswordError("Password must be greater than 8 characters");
    } else if (password.length >= 8) {
      setShowPasswordError(false);
    }
  };

  const confirmPasswordValidation = (value) => {
    if (value !== password)
      setShowPasswordError("Password and Confirm Password should be same.");
    else setShowPasswordError(false);
  };

  const handleSchoolName = () => {
    clearTimeout(timeoutRef.current);
    setSchoolName(schoolNameRef.current.value);
    if (!schoolNameRef.current.value) {
      setShowSchoolNameContainer(false);
      setSchoolNameList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getSchoolsList(schoolNameRef.current.value);
      }, 1000);
    }
  };

  const handleSelectedSchoolName = (item) => {
    console.log("tt",item);
    setSelectedSchool([...selectedSchool, item]);
    setSchoolNameList([]);
    setSchoolName("");
    setShowSchoolNameContainer(false);
  };

  const removeSchoolName = (value) => {
    let filteredValue = selectedSchool?.filter((item) => item !== value);
    setSelectedSchool(filteredValue);
  };

  const saveButtonHandler = () => {
    let arr = selectedSchool.map((item) => item.id);
    let obj = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      recovery_email: recoveryEmail,
      mobile: mobile,
      is_super_counselor: promote,
      type: "counselor",
      schools: arr,
      user_id: modify?.counselor?.id,
    };
    obj.password = password;
    obj.password_confirm = confirmPassword;
    console.log(obj);
    if (modify) {
      GetAdminService.updateCounselor(obj)
        .then((data) => {
          console.log("data from the service", data);
          setNull();
          getPageData(school_id);
          setOpenCreateCounselor(false);
        })
        .catch((error) => {
          console.log("error from the service", error, error?.response);
          swal({
            text: error?.response?.data?.message,
            icon: "warning",
            dangerMode: true,
            buttons: {
              cancel: true,
              confirm: true,
            },
            closeOnClickOutside: true,
          }).then((value) => {
            console.log("value", value);
          });
        });
    } else {
      GetAdminService.saveCounselor(obj)
        .then((data) => {
          console.log("data from the service", data);
          setNull();
          getPageData(school_id);
          setOpenCreateCounselor(false);
          swal({
            text: data?.data?.message,
            icon: "success",
            buttons: {
              OK:true
            },
            closeOnClickOutside: true,
          })
        })
        .catch((error) => {
          console.log("error from the service", error, error?.response);
          swal({
            text: error?.response?.data?.message,
            icon: "warning",
            dangerMode: true,
            buttons: {
              cancel: true,
              confirm: true,
            },
            closeOnClickOutside: true,
          }).then((value) => {
            console.log("value", value);
          });
        });
    }
  };

  const deleteCounslor = () => {
    GetAdminService.deleteCounslor(modify?.counselor?.id)
      .then((data) => {
        console.log("student from the service", data);
        swal({
          text: "Counselor deleted successfully!",
          icon: "success",
          buttons: {
            confirm: true,
          },
          closeOnClickOutside: false,
        });
        setNull();
        getPageData(school_id);
        setOpenCreateCounselor(false);
      })
      .catch((error) => {
        console.log("error from the service", error);
      });
    setOpenDeleteModal(false);
  };

  useEffect(() => {
    if (modify) {
      modifyData();
    } else {
      setSelectedSchool([{ name: school_name, id: school_id }]);
    }
  }, []);

  return (
    <Fragment>
      <div className="create-student-container">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p style={{ fontSize: "18px" }}>
            {modify ? "Modify Counselor" : "New Counselor"}
          </p>
          <FontAwesomeIcon
            icon={faTimes}
            style={{ cursor: "pointer", fontSize: "18px" }}
            onClick={() => {
              setOpenCreateCounselor(false);
              setNull();
            }}
          />
        </div>
        <div style={{ padding: "0 30px" }}>
          <div
            className="flex"
            style={{
              marginTop: "10px",
              justifyContent: "space-between",
              position: "relative",
            }}
          >
            <p
              style={{ width: "20%", fontSize: "14px" }}
              className="bold no-margin-bottom"
            >
              Add School
            </p>
            <input
              type="text"
              ref={schoolNameRef}
              style={{ width: "75%" }}
              placeholder="Type the school name"
              value={schoolName}
              onChange={handleSchoolName}
              autoComplete="off"
            />
            <FontAwesomeIcon
              style={{
                fontSize: "12px",
                position: "absolute",
                right: "5px",
                top: "5px",
              }}
              icon={faAsterisk}
              color="red"
            />

            {showSchoolNameContainer && (
              <div>
                <ul className="admin-school-name-list">
                  {schoolNameLoading && <CustomLoader />}
                  {schoolNameList?.length > 0 &&
                    schoolNameList.map((item, index) => (
                      <li
                        onClick={() => handleSelectedSchoolName(item)}
                        key={index}
                        className="flex"
                        style={{ paddingBottom: "10px", paddingLeft:"10px", cursor: "pointer" }}
                      >
                        <span>{item.name}</span>
                      </li>
                    ))}
                </ul>
              </div>
            )}
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              width: "100%",
              marginTop: "5px",
            }}
          >
            {console.log("data1",selectedSchool)}
            {selectedSchool?.length > 0 &&
              selectedSchool?.map((item) => (
                <div
                  style={{
                    background: "#009900",
                    color: "white",
                    padding: "3px 5px",
                    cursor: "pointer",
                    fontSize: "14px",
                    margin: "0px 2px",
                  }}
                >
                  {item?.name}
                  <FontAwesomeIcon
                    icon={faTimes}
                    color="white"
                    style={{ marginLeft: "5px" }}
                    onClick={() => removeSchoolName(item)}
                  />
                </div>
              ))}
          </div>
        </div>
        <div style={{ marginTop: "30px" }}>
          <p
            style={{
              fontSize: "14px",
              fontWeight: "400",
              borderBottom: "1px solid #e5e5e5",
            }}
          >
            Personal information
          </p>
          <div style={{ padding: "0 30px" }}>
            <div
              className="flex"
              style={{
                marginTop: "15px",
                justifyContent: "space-between",
                position: "relative",
              }}
            >
              <p
                style={{ width: "20%", fontSize: "14px" }}
                className="bold no-margin-bottom"
              >
                First Name
              </p>
              <input
                type="text"
                style={{ width: "75%" }}
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <FontAwesomeIcon
                style={{ fontSize: "12px", position: "absolute", right: "5px" }}
                icon={faAsterisk}
                color="red"
              />
            </div>
            <div
              className="flex"
              style={{
                marginTop: "15px",
                justifyContent: "space-between",
                position: "relative",
              }}
            >
              <p
                style={{ width: "20%", fontSize: "14px" }}
                className="bold no-margin-bottom"
              >
                Last Name
              </p>
              <input
                type="text"
                style={{ width: "75%" }}
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              <FontAwesomeIcon
                style={{ fontSize: "12px", position: "absolute", right: "5px" }}
                icon={faAsterisk}
                color="red"
              />
            </div>
          </div>
        </div>
        <div style={{ marginTop: "30px" }}>
          <p
            style={{
              fontSize: "14px",
              fontWeight: "400",
              borderBottom: "1px solid #e5e5e5",
            }}
          >
            Contact
          </p>
          <div style={{ padding: "0 30px" }}>
            <div
              className="flex"
              style={{
                marginTop: "15px",
                justifyContent: "space-between",
                position: "relative",
              }}
            >
              <p
                style={{ width: "20%", fontSize: "14px" }}
                className="bold no-margin-bottom"
              >
                Email
              </p>
              <input
                type="email"
                style={{ width: "75%" }}
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value.toLowerCase())}
              />
              <FontAwesomeIcon
                style={{ fontSize: "12px", position: "absolute", right: "5px" }}
                icon={faAsterisk}
                color="red"
              />
            </div>

            <div
              className="flex"
              style={{
                marginTop: "15px",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <p
                style={{ width: "20%", fontSize: "14px" }}
                className="bold no-margin-bottom"
              >
                Secondary Email
              </p>
              <div style={{ width: "75%" }}>
                <input
                  type="email"
                  style={{ width: "100%" }}
                  placeholder="Secondary Email"
                  value={recoveryEmail}
                  onChange={(e) => setRecoveryEmail(e.target.value.toLowerCase())}
                />
                <p className="help-block">
                  Used in case account needs to be recovered
                </p>
              </div>
            </div>

            <div
              className="flex"
              style={{
                marginTop: "15px",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <p
                style={{ width: "20%", fontSize: "14px" }}
                className="bold no-margin-bottom"
              >
                Mobile
              </p>
              <div style={{ width: "75%" }}>
                <input
                  type="text"
                  style={{ width: "100%" }}
                  placeholder="+19999999999"
                  onChange={(e) => setMobile(e.target.value)}
                  value={mobile}
                />
                <p className="help-block">Hint: +13238511115</p>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div style={{ marginTop: "10px" }}>
            <p
              style={{
                fontSize: "14px",
                fontWeight: "400",
                borderBottom: "1px solid #e5e5e5",
              }}
            >
              User information
            </p>
          </div>
          <div style={{ padding: "0 30px" }}>
            <div
              className="flex"
              style={{
                marginTop: "15px",
                justifyContent: "space-between",
                position: "relative",
              }}
            >
              <p
                style={{ width: "20%", fontSize: "14px" }}
                className="bold no-margin-bottom"
              >
                Password
              </p>
              <input
                type="password"
                style={{ width: "75%" }}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onBlur={() => passwordValidation(password)}
              />
              <FontAwesomeIcon
                style={{ fontSize: "12px", position: "absolute", right: "5px" }}
                icon={faAsterisk}
                color="red"
              />
            </div>
            <div
              className="flex"
              style={{
                marginTop: "15px",
                justifyContent: "space-between",
                position: "relative",
              }}
            >
              <p
                style={{ width: "20%", fontSize: "14px" }}
                className="bold no-margin-bottom"
              >
                Confirm Password
              </p>
              <input
                type="password"
                style={{ width: "75%" }}
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                onBlur={() => confirmPasswordValidation(confirmPassword)}
              />
              <FontAwesomeIcon
                style={{ fontSize: "12px", position: "absolute", right: "5px" }}
                icon={faAsterisk}
                color="red"
              />
            </div>
          </div>
          <div
            style={{
              margin: "10px 20px",
            }}
          >
            <input
              type="checkbox"
              style={{ marginRight: "5px" }}
              value={promote}
              onChange={() => setPromote(!promote)}
              checked={promote}
            />
            <span style={{ fontSize: "14px", color: "#737373" }}>
              Please Check the Box to promote as School Admin.
            </span>
          </div>
          {showPasswordError && (
            <p style={{ color: "#a94442", margin: "10px 20px" }}>
              {showPasswordError}
            </p>
          )}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            gap: "20px",
            margin: "20px 20px 30px 0",
          }}
        >
          {modify && (
            <button
              className="cancel-modal-button"
              onClick={() => setOpenDeleteModal(true)}
            >
              <FontAwesomeIcon icon={faTrash} />
              &nbsp;Delete
            </button>
          )}
          {!modify ?
          <button
            onClick={saveButtonHandler}
            disabled={
              !(
                email &&
                firstName &&
                lastName &&
                password &&
                confirmPassword &&
                !showPasswordError
              )
            }
            className={
              !(
                firstName &&
                email &&
                lastName &&
                password &&
                confirmPassword &&
                !showPasswordError
              )
                ? "disabled-modal-button"
                : "save-modal-button"
            }
          >
            <FontAwesomeIcon
              icon={faSave}
              style={{
                marginRight: "5px",
                marginTop: "3px",
              }}
            />
            Save
          </button> : <button
            onClick={saveButtonHandler}
            className="save-modal-button"
          >
            <FontAwesomeIcon
              icon={faSave}
              style={{
                marginRight: "5px",
                marginTop: "3px",
              }}
            />
            Save
          </button> }
        </div>
      </div>
      {openDeleteModal && (
        <MessageModal
          setIsOpen={setOpenDeleteModal}
          isOpen={openDeleteModal}
          data={{
            function1: deleteCounslor,
            message: "Are you sure you want to delete?",
          }}
        />
      )}
    </Fragment>
  );
};
export default CreateCounselor;
